import { Injectable } from '@angular/core';

import { App } from '@capacitor/app';

import { from, map, Observable } from 'rxjs';

import { AppType } from '../../../../types/enums/app/app-type.enum';
import { Platform } from '../../../../types/enums/platform/platform.enum';
import { MobileAppService } from '../../../mobile-app/mobile-app.service';
import { VersionCheckRequest } from '../../domain/services/actual-app-version-client';

/**
 * Factory for creating version check requests
 */
@Injectable({
    providedIn: 'root'
})
export class VersionCheckRequestFactory {
    constructor(private mobileAppService: MobileAppService) {}

    /**
     * Creates a version check request
     * @param appType The type of app (client or guard)
     * @returns An Observable that emits a VersionCheckRequest
     */
    createRequest(appType: AppType): Observable<VersionCheckRequest> {
        return from(App.getInfo()).pipe(
            map(appInfo => {
                const platform = this.mobileAppService.ios ? Platform.IOS : Platform.ANDROID;

                // Create a version check request
                const request: VersionCheckRequest = {
                    version: appInfo.version,
                    platform,
                    app_type: appType
                };

                return request;
            })
        );
    }

    /**
     * Checks if the app is a mobile app
     * @returns True if the app is a mobile app, false otherwise
     */
    isMobileApp(): boolean {
        return this.mobileAppService.mobileApp;
    }
}
